import { render } from "./ProhorWidget.vue?vue&type=template&id=1677bbd0&scoped=true"
import script from "./ProhorWidget.vue?vue&type=script&lang=js"
export * from "./ProhorWidget.vue?vue&type=script&lang=js"

import "./ProhorWidget.vue?vue&type=style&index=0&id=1677bbd0&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1677bbd0"]])

export default __exports__